export enum TAG {
	NEW = "new",
	SALE = "sale"
}
